(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_kotlin.js', './kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_kotlin.js'), require('./kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.js'));
  else {
    if (typeof kotlin_kotlin === 'undefined') {
      throw new Error("Error loading module 'kotlin_city_smartb_i2_i2_commons_domain'. Its dependency 'kotlin_kotlin' was not found. Please, check whether 'kotlin_kotlin' is loaded prior to 'kotlin_city_smartb_i2_i2_commons_domain'.");
    }
    if (typeof kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core === 'undefined') {
      throw new Error("Error loading module 'kotlin_city_smartb_i2_i2_commons_domain'. Its dependency 'kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core' was not found. Please, check whether 'kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core' is loaded prior to 'kotlin_city_smartb_i2_i2_commons_domain'.");
    }
    root.kotlin_city_smartb_i2_i2_commons_domain = factory(typeof kotlin_city_smartb_i2_i2_commons_domain === 'undefined' ? {} : kotlin_city_smartb_i2_i2_commons_domain, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  //region block: imports
  var CoroutineImpl = kotlin_kotlin.$crossModule$.CoroutineImpl;
  var Unit_getInstance = kotlin_kotlin.$crossModule$.Unit_getInstance;
  var THROW_CCE = kotlin_kotlin.$crossModule$.THROW_CCE;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$crossModule$.CoroutineScope;
  var isInterface = kotlin_kotlin.$crossModule$.isInterface;
  var _get_COROUTINE_SUSPENDED__2870145053 = kotlin_kotlin.$crossModule$._get_COROUTINE_SUSPENDED__2870145053;
  var GlobalScope_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$crossModule$.GlobalScope_getInstance;
  var promise$default = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$crossModule$.promise$default;
  var SuspendFunction1 = kotlin_kotlin.$crossModule$.SuspendFunction1;
  //endregion
  'use strict';
  //region block: pre-declaration
  ClientJs$doCall$slambda.prototype = Object.create(CoroutineImpl.prototype);
  ClientJs$doCall$slambda.prototype.constructor = ClientJs$doCall$slambda;
  //endregion
  function ClientJs$doCall$slambda($fnc, resultContinuation) {
    this.$fnc_1 = $fnc;
    CoroutineImpl.call(this, resultContinuation);
  }
  ClientJs$doCall$slambda.prototype.invoke_uet3ln_k$ = function ($this$promise, $cont) {
    var tmp = this.create_b6qu53_k$($this$promise, $cont);
    tmp._set_result__3294305178_cat9z_k$(Unit_getInstance());
    tmp._set_exception__4196179798_3fu58l_k$(null);
    return tmp.doResume_5yljmg_k$();
  };
  ClientJs$doCall$slambda.prototype.invoke_5zdxxo_k$ = function (p1, $cont) {
    return this.invoke_uet3ln_k$((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $cont);
  };
  ClientJs$doCall$slambda.prototype.doResume_5yljmg_k$ = function () {
    var suspendResult = this._get_result__3382885006_f31376_k$();
    $sm: do
      try {
        var tmp = this._get_state__3614753120_b8zcm8_k$();
        switch (tmp) {
          case 0:
            this._set_exceptionState__118868437_8fc1n_k$(2);
            this._set_state__1256591060_i39zdo_k$(1);
            suspendResult = this.$fnc_1(this);
            if (suspendResult === _get_COROUTINE_SUSPENDED__2870145053()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            return JSON.parse(JSON.stringify(result));
          case 2:
            throw this._get_exception__1672948706_ro13he_k$();
        }
      } catch ($p) {
        if (this._get_exceptionState__1662596297_rhv7ih_k$() === 2) {
          throw $p;
        } else {
          this._set_state__1256591060_i39zdo_k$(this._get_exceptionState__1662596297_rhv7ih_k$());
          this._set_exception__4196179798_3fu58l_k$($p);
        }
      }
     while (true);
  };
  ClientJs$doCall$slambda.prototype.create_b6qu53_k$ = function ($this$promise, completion) {
    var i = new ClientJs$doCall$slambda(this.$fnc_1, completion);
    i.$this$promise_1 = $this$promise;
    return i;
  };
  ClientJs$doCall$slambda.$metadata$ = {
    simpleName: 'ClientJs$doCall$slambda',
    kind: 'class',
    interfaces: [],
    suspendArity: [1]
  };
  function ClientJs$doCall$slambda_0($fnc, resultContinuation) {
    var i = new ClientJs$doCall$slambda($fnc, resultContinuation);
    var l = function ($this$promise, $cont) {
      return i.invoke_uet3ln_k$($this$promise, $cont);
    };
    l.$arity = 1;
    return l;
  }
  function ClientJs() {
  }
  ClientJs.prototype.doCall = function (fnc) {
    var tmp = GlobalScope_getInstance();
    return promise$default(tmp, null, null, ClientJs$doCall$slambda_0(fnc, null), 3, null);
  };
  ClientJs.$metadata$ = {
    simpleName: 'ClientJs',
    kind: 'class',
    interfaces: []
  };
  //region block: exports
  function $jsExportAll$(_) {
    var $i2 = _.i2 || (_.i2 = {});
    var $i2$commons = $i2.commons || ($i2.commons = {});
    var $i2$commons$http = $i2$commons.http || ($i2$commons.http = {});
    $i2$commons$http.ClientJs = ClientJs;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_city_smartb_i2_i2_commons_domain.js.map